export default "__VITE_ASSET__Bt$lX7o$__"